import { FormAutocompleteMultiInput, FormToggleSwitch } from '@/components';
import type { Option } from '@/components/inputs/AutocompleteInput';
import type { Control } from 'react-hook-form';

interface OperatorAccessCardProps {
  control: Control<any>;
  isLoadingOptions: boolean;
  operatorsOptions: Option[];
  subOperatorsOptions: Option[];
  hasSelectedOperators: boolean;
  subOperatorsIncludeAll: boolean;
}

const OperatorAccessCard = ({
  control,
  isLoadingOptions,
  operatorsOptions,
  subOperatorsOptions,
  hasSelectedOperators,
  subOperatorsIncludeAll,
}: OperatorAccessCardProps) => (
  <div className='min-w-0 flex-1 rounded-lg border border-gray-200 bg-white p-6 shadow-sm'>
    <h3 className='mb-4 text-lg font-semibold text-gray-800'>
      Operador logístico
    </h3>
    <div className='min-w-0 overflow-hidden pt-3'>
      <FormAutocompleteMultiInput
        name='operators.selected'
        placeholder={isLoadingOptions ? 'Cargando...' : 'Seleccionar operadores'}
        control={control}
        options={operatorsOptions}
        required
      />
      <p className='mt-1 text-xs text-gray-500'>
        Selecciona los operadores logísticos que quieras incluir.
      </p>
    </div>
    {hasSelectedOperators && (
      <div className='mt-6 border-t border-gray-200 pt-6'>
        <h4 className='text-md mb-4 font-semibold text-gray-700'>
          Sub operador
        </h4>
        <div className='min-w-0 overflow-hidden pt-2'>
          <FormAutocompleteMultiInput
            name='operators.subOperators.selected'
            placeholder='Seleccionar sub operadores'
            control={control}
            options={subOperatorsOptions}
            disabled={subOperatorsIncludeAll}
          />
          <p className='mt-1 text-xs text-gray-500'>
            Selecciona los sub operadores logísticos que quieras incluir.
          </p>
        </div>
        <div className='mt-4 flex items-center'>
          <FormToggleSwitch
            name='operators.subOperators.includeAll'
            control={control}
          />
          <span className='ml-2 text-sm text-gray-700'>
            ¿Desea excluir alguno de los sub operadores?
          </span>
        </div>
        {subOperatorsIncludeAll && (
          <div className='min-w-0 overflow-hidden pt-2'>
            <FormAutocompleteMultiInput
              name='operators.subOperators.excluded'
              placeholder='Excluir sub operadores'
              control={control}
              options={subOperatorsOptions}
              disabled={!subOperatorsIncludeAll}
            />
            <p className='mt-1 text-xs text-gray-500'>
              Selecciona los sub operadores que quieras excluir (todos los
              demás estarán incluidos).
            </p>
          </div>
        )}
      </div>
    )}
  </div>
);

export default OperatorAccessCard;
